module.exports = __webpack_public_path__ + "static/media/stage_2.ea07a565.png";